<template>
<div>
  <div class="row">
    <div v-bind:class="['container container-paddingb', {'mt-5': width > 1025}]">
      <div class="row mt-5">
        <div class="col-md-12"><h1 class="title dark-grey roboto-style font-weight-bold">Enterprise software development</h1></div>
        <div class="col-lg-7 col-lg-10 col-md-12 mt-2"><p class="description inter-style medium-grey">We offer web and mobile solutions, highly customized to your specific needs, to digitally transform your business.</p></div>
      </div>
    </div>
  </div>
  <div v-if="width > 1027" class="container container-paddingb">
    <div class="row mx-0">
      <a id="0" @click.stop.prevent="whitebox_click" class="col-md-2 whitebox px-lg-2 px-sm-1 tabs">
        <icnserv1></icnserv1>
        <p class="roboto-style xs-descr" style="margin-top: 65px;">Software development</p>
      </a>
      <a id="1" @click.stop.prevent="whitebox_click" class="col-md-2 whitebox px-lg-2 px-sm-1 tabs">
        <icnserv2></icnserv2>
        <p class="roboto-style xs-descr" style="margin-top: 85px;">E-commerce</p>
      </a>
      <a id="2" @click.stop.prevent="whitebox_click" class="col-md-2 whitebox px-lg-2 px-sm-1 tabs">
        <icnserv3></icnserv3>
        <p class="roboto-style xs-descr" style="margin-top: 85px;">CyberSecurity</p>
      </a>
      <a id="3" @click.stop.prevent="whitebox_click" class="col-md-2 whitebox px-lg-2 px-sm-1 tabs">
        <icnserv4></icnserv4>
        <p class="roboto-style xs-descr" style="margin-top: 85px;">Blockchain</p>
      </a>
      <a id="4" @click.stop.prevent="whitebox_click" class="col-md-2 whitebox px-lg-2 px-sm-1 tabs">
        <icnserv5></icnserv5>
        <p class="roboto-style xs-descr" style="margin-top: 65px;">Big Data Analytics</p>
      </a>
      <a id="5" @click.stop.prevent="whitebox_click" class="col-md-2 whitebox px-lg-2 px-sm-0 tabs">
        <icnserv6></icnserv6>
        <p class="roboto-style xs-descr mt-5 col-lg-12 col-md-8 px-1">Network and System Administration</p>
      </a>
      <a id="6" @click.stop.prevent="whitebox_click" class="col-md-2 whitebox px-lg-2 px-sm-0 tabs">
        <icnserv7></icnserv7>
        <p class="roboto-style xs-descr mt-5 col-md-10 px-1">24/7 Support & Maintenance</p>
      </a>
    </div>
  </div>
  <div class="row container-paddingb">
      <b-tabs  v-bind:vertical="width <= 1027" v-bind:class="[{initial_padding: width > 1027}, 'w-100']" v-model="tabindex" pills card>
        <b-tab @click="tabsBehaviour" active title="Software development">
          <b-card-text>
              <div class="row mt-lg-5 xs_margint mb-5">
                <div class="col-md-4"><p v-bind:class="['title robot-style dark-grey tabs_title', {'mb-0':width<=768}]">Software development</p></div>
                <div class="col-md-8 pl-sm-5 pl-lg-2 pr-0 pl-sm-0">
                  <div v-bind:class="['row description lighter-grey small-description inter-style font-weight-normal xs_margint', {'mt-4' : width > 1023}]">
                    <div class="col-md-6 pr-2">
                      <p>Our bespoke software development services help meet unique requirements at competitive costs. Our services include custom mobile apps, whether Hybrid apps, cross-platform, Android, or iOS. Our approach is innovative and creative to provide your business efficiency, scalability, and profitability.</p>
                    </div>
                    <div class="col-md-6 pr-2" v-bind:style="width > 1023 ? 'padding-left: 18px' : ''">
                      <p>We delivered custom projects successfully to customers from 2 continents, using the technologies that matched their needs best. One of our significant advantages is the adaptability and the capability to work with a broad range of programs, even new technologies. This way, we ensure 100% compatibility with your business processes.
                      </p>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-md-12 inter-style small-description font-weight-normal dark-grey">
                      <p>How can we help</p>
                      <ul class="pl-3">
                        <li>Business Process Automation Software/Services/Solutions</li>
                        <li>Enterprise Solutions</li>
                        <li>Mobile Apps Development</li>
                        <li>iOS/Android</li>
                        <li>Hybrid Apps</li>
                        <li>Decoupled software architecture</li>
                        <li>Web Development</li>
                        <li>Progressive Web Apps</li>
                      </ul>
                      <p v-bind:class="['xs_margint', {'mt-5' : width > 1023}]">Clients that trusted us with Software Development</p>
                    </div>
                  </div>
                  <div v-bind:class="['row container-fluid', {'px-0 mx-0' : width <= 768}, {'pl-0' : width > 768}]">
                    <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'justify-content-start' : width > 1023}, {'justify-content-center': width <= 1023}]"><img class="groupon-logo" src="../assets/groupon.png"/></div>
                    <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'justify-content-center' : width < 1024}, {'justify-content-start' : width >= 1024}]"><img class="vodafone-logo" src=".././assets/vodafone.png"/></div>
                    <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'justify-content-center' : width < 1024}, {'justify-content-start' : width >= 1024}, {' mt-4' : width < 576}]"><img class="gdfsuez-logo" src=".././assets/gdf-suez.png"/></div>
                    <div v-bind:class="['col-lg-2 col-sm-4 d-flex align-items-center col-6', {'mt-4' : width <= 768}, {'justify-content-center' : width < 1024}, {'justify-content-end' : width >= 1024}]"><img  class="orange-logo" src=".././assets/orange.png"/></div>
                    <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {' mt-4' : width <= 768}, {'justify-content-center' : width < 1024}, {'justify-content-end' : width >= 1024}]"><img class="ferrero-logo" src=".././assets/ferrero.png"/></div>
                    <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'mt-4' : width <= 768}, {'justify-content-center' : width < 1024}, {'justify-content-end' : width >= 1024}]"><img class="cocacola-logo" src=".././assets/coca-cola.png"/></div>
                  </div>
                </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab @click="tabsBehaviour" title="E-commerce">
          <b-card-text>
            <div class="row mt-lg-5 xs_margint mb-5">
              <div class="col-md-4"><p v-bind:class="['title robot-style dark-grey tabs_title', {'mb-0':width<=768}]">E-commerce</p></div>
              <div class="col-md-8 pl-sm-3 pl-lg-2 pr-0">
                <div v-bind:class="['row description lighter-grey small-description inter-style font-weight-normal xs_margint', {'mt-4' : width > 1023}]">
                  <div class="col-md-6 pr-2">
                    <p>We deliver eCommerce end to end solutions, which provide a smarter, more personalized shopping experience across all customer touchpoints thanks to a headless approach. It allows us to drive consumer channel-specific user experiences while still having a robust B2C e-commerce engine.</p>
                  </div>
                  <div class="col-md-6 pr-2" v-bind:style="width > 1023 ? 'padding-left: 18px' : ''">
                    <p>Using our eCommerce services will help you take advantage of mobile-optimized experiences and enjoy the power of AI to drive better results, insights, and customer experiences. All seasoned with extensibility to add third-party commerce services or extensions.</p>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-md-12 inter-style small-description font-weight-normal dark-grey">
                    <p>How can we help</p>
                    <ul class="pl-3">
                      <li>Enterprise Solutions</li>
                      <li>Custom eCommerce development</li>
                      <li>Platform-based development using both community edition or enterprise platforms (such as Magento, Craft Commerce, OpenCart, PrestaShop)</li>
                      <li>Scaling and optimization of the existing solution</li>
                      <li>Integration with other business systems</li>
                      <li>Newsletters (Email, Whatsapp, SMS)</li>
                    </ul>
                    <p v-bind:class="['xs_margint', {'mt-5' : width > 1023}]">Clients that trusted us with Software Development</p>
                  </div>
                </div>
                <div v-bind:class="['row container-fluid', {'px-0 mx-0' : width <= 768}, {'pl-0' : width > 768}]">
                  <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'justify-content-start' : width > 1023}, {'justify-content-center': width <= 1023}]"><img class="groupon-logo" src="../assets/groupon.png"/></div>
                    <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'justify-content-center' : width < 1024}, {'justify-content-start' : width >= 1024}]"><img class="vodafone-logo" src=".././assets/vodafone.png"/></div>
                    <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {' mt-4' : width < 576}, {'justify-content-center' : width < 1024}, {'justify-content-start' : width >= 1024}]"><img class="gdfsuez-logo" src=".././assets/gdf-suez.png"/></div>
                    <div v-bind:class="['col-lg-2 col-sm-4 d-flex align-items-center col-6', {'mt-4' : width <= 991}, {'justify-content-center' : width < 1024}, {'justify-content-end' : width >= 1024}]"><img  class="orange-logo" src=".././assets/orange.png"/></div>
                    <div v-bind:class="['col-lg-2 col-sm-4 d-flex align-items-center col-6', {'mt-4' : width <= 991}, {'justify-content-center' : width < 1024}, {'justify-content-end' : width >= 1024}]"><img class="ferrero-logo" src=".././assets/ferrero.png"/></div>
                  </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab @click="tabsBehaviour" title="Cyber Security">
          <b-card-text>
            <div class="row mt-lg-5 xs_margint mb-5">
              <div class="col-md-4"><p v-bind:class="['title robot-style dark-grey tabs_title', {'mb-0':width<=768}]">Cyber Security</p></div>
              <div class="col-md-8 pl-sm-5 pl-lg-2 pr-0">
                <div v-bind:class="['row description lighter-grey small-description inter-style font-weight-normal xs_margint', {'mt-4' : width > 1023}]">
                  <div class="col-md-6 pr-2">
                    <p>At Unknown Software, we believe in the power of prevention when it comes to cybersecurity. Prevention will offer you an edge over the competition both financially since prevention is a lot cheaper than fixing any potential risk and business-wise because it helps you ensure that the processes run as usual when prevention is in place.</p>
                  </div>
                  <div class="col-md-6 pr-2" v-bind:style="width > 1023 ? 'padding-left: 18px' : ''">
                    <p>But we also offer a tailored incident response to rapidly react in case of a breach, a security threat, or cyberattack. This process allows us to detect any problem, minimize its effects, contain the damage, and identify its root cause to reduce future risks. We know the importance of quick response in critical situations resulting in dedicated teams who work 24/7 to provide early identification and effective response.</p>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-md-12 inter-style small-description font-weight-normal dark-grey">
                    <p>How can we help</p>
                    <ul class="pl-3">
                      <li>Enterprise Solutions</li>
                      <li>Security Audits</li>
                      <li>Vulnerability Testing</li>
                      <li>Incident Response</li>
                      <li>Mitigation</li>
                    </ul>
                    <p v-bind:class="['xs_margint', {'mt-5' : width > 1023}]">Clients that trusted us with Software Development</p>
                  </div>
                </div>
                <div v-bind:class="['row container-fluid', {'px-0 mx-0' : width <= 768}, {'pl-0' : width > 768}]">
                  <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'justify-content-start' : width > 1023}, {'justify-content-center': width <= 1023}]"><img class="groupon-logo" src="../assets/groupon.png"/></div>
                    <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'justify-content-center' : width < 1024}, {'justify-content-start' : width >= 1024}]"><img class="vodafone-logo" src=".././assets/vodafone.png"/></div>
                    <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'mt-4' : width <= 575}, {'justify-content-center' : width < 1024}, {'justify-content-start' : width >= 1024}]"><img class="gdfsuez-logo" src=".././assets/gdf-suez.png"/></div>
                    <div v-bind:class="['col-lg-2 col-sm-4 d-flex align-items-center col-6', {'mt-4' : width <= 993}, {'justify-content-center' : width < 1024}, {'justify-content-end' : width >= 1024}]"><img  class="orange-logo" src=".././assets/orange.png"/></div>
                  </div>

              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab @click="tabsBehaviour" title="Blockchain">
          <b-card-text>
            <div class="row mt-lg-5 xs_margint mb-5">
              <div class="col-md-4"><p v-bind:class="['title robot-style dark-grey tabs_title', {'mb-0':width<=768}]">Blockchain</p></div>
              <div class="col-md-8 pl-sm-5 pl-lg-2 pr-0">
                <div v-bind:class="['row description lighter-grey small-description inter-style font-weight-normal xs_margint', {'mt-4' : width > 1023}]">
                  <div class="col-md-6 pr-2">
                    <p>Forget about chaotic data management, poor network infrastructure, and outdated approaches to recording and tracking assets. Blockchain provides faster and more secure transactions, streamline and automate back-office operations, together with leveraging cloud-based technologies. </p>
                  </div>
                  <div class="col-md-6 pr-2" v-bind:style="width > 1023 ? 'padding-left: 18px' : ''">
                    <p>Applying blockchain to enterprises means creating relevant, scalable solutions that drive value for your organization. Our tailored approach incorporates strategy, security, cost, privacy, performance, risk management, and more.</p>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-md-12 inter-style small-description font-weight-normal dark-grey">
                    <p>How can we help</p>
                    <ul class="pl-3">
                      <li>Decentralized Applications</li>
                      <li>Smart contracts</li>
                      <li>Tokens</li>
                    </ul>
                    <p v-bind:class="['xs_margint', {'mt-5' : width > 1023}]">Clients that trusted us with Software Development</p>
                  </div>
                </div>
                <div v-bind:class="['row container-fluid', {'px-0 mx-0' : width <= 768}, {'pl-0' : width > 768}]">
                  <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'justify-content-start' : width > 1023}, {'justify-content-center': width <= 1023}]"><img class="groupon-logo" src="../assets/groupon.png"/></div>
                  <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'justify-content-center' : width < 1024}, {'justify-content-start' : width >= 1024}]"><img class="vodafone-logo" src=".././assets/vodafone.png"/></div>
                  <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center',{'mt-4' : width <= 575}, {'justify-content-center' : width < 1024}, {'justify-content-start' : width >= 1024}]"><img class="gdfsuez-logo" src=".././assets/gdf-suez.png"/></div>
                  <div v-bind:class="['col-lg-2 col-sm-4 d-flex align-items-center col-6', {'mt-4' : width <= 768}, {'justify-content-center' : width < 1024}, {'justify-content-end' : width >= 1024}]"><img  class="orange-logo" src=".././assets/orange.png"/></div>
                  <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {' mt-4' : width <= 768}, {'justify-content-center' : width < 1024}, {'justify-content-end' : width >= 1024}]"><img class="ferrero-logo" src=".././assets/ferrero.png"/></div>
                  <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'mt-4' : width <= 768}, {'justify-content-center' : width < 1024}, {'justify-content-end' : width >= 1024}]"><img class="cocacola-logo" src=".././assets/coca-cola.png"/></div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab @click="tabsBehaviour" title="Big Data Analytics">
          <b-card-text>
            <div class="row mt-lg-5 xs_margint mb-5">
              <div class="col-md-4"><p v-bind:class="['title robot-style dark-grey tabs_title', {'mb-0':width<=768}]">Big Data Analytics</p></div>
              <div class="col-md-8 pl-sm-5 pl-lg-2 pr-0">
                <div v-bind:class="['row description lighter-grey small-description inter-style font-weight-normal xs_margint', {'mt-4' : width > 1023}]">
                  <div class="col-md-6 pr-2">
                    <p>We present big, complex data in a simple and easily comprehensible way, adapting it to your business goals. We combine traditional methods like ETL and BI with breakthrough technologies in Machine Learning and Artificial Intelligence, to make your business data-driven.</p>
                  </div>
                  <div class="col-md-6 pr-2" v-bind:style="width > 1023 ? 'padding-left: 18px' : ''">
                    <p>Putting data to good use is the key to staying ahead of the competition and for reacting to future challenges. Big data predictive analytics transforms the corporate decision-making and strategic planning of enterprises.</p>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-md-12 inter-style small-description font-weight-normal dark-grey">
                    <p>How can we help</p>
                    <ul class="pl-3">
                      <li>Decentralized Applications</li>
                      <li>Smart contracts</li>
                      <li>Tokens</li>
                    </ul>
                    <p v-bind:class="['xs_margint', {'mt-5' : width > 1023}]">Clients that trusted us with Software Development</p>
                  </div>
                </div>
                <div v-bind:class="['row container-fluid', {'px-0 mx-0' : width <= 768}, {'pl-0' : width > 768}]">
                  <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'justify-content-start' : width > 1023}, {'justify-content-center': width <= 1023}]"><img class="groupon-logo" src="../assets/groupon.png"/></div>
                  <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'justify-content-center' : width < 1024}, {'justify-content-start' : width >= 1024}]"><img class="vodafone-logo" src=".././assets/vodafone.png"/></div>
                  <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'mt-4' : width <= 575}, {'justify-content-center' : width < 1024}, {'justify-content-start' : width >= 1024}]"><img class="gdfsuez-logo" src=".././assets/gdf-suez.png"/></div>
                  <div v-bind:class="['col-lg-2 col-sm-4 d-flex align-items-center col-6', {'mt-4' : width <= 993}, {'justify-content-center' : width < 1024}, {'justify-content-end' : width >= 1024}]"><img  class="orange-logo" src=".././assets/orange.png"/></div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab @click="tabsBehaviour" title="Network and System Administration">
          <b-card-text>
            <div class="row mt-lg-5 xs_margint mb-5">
              <div class="col-md-4"><p v-bind:class="['title robot-style dark-grey tabs_title', {'mb-0':width<=768}]">Network and System Administration</p></div>
              <div class="col-md-8 pl-sm-5 pl-lg-2 pr-0">
                <div v-bind:class="['row description lighter-grey small-description inter-style font-weight-normal xs_margint', {'mt-4' : width > 1023}]">
                  <div class="col-md-6 pr-2">
                    <p>Our team of carefully selected developers provides 24/7, high-quality, and on-demand system administration and remote monitoring services. We offer a wide range of services to cover all your needs and to ensure your business is always functioning correctly and smoothly.</p>
                  </div>
                  <div class="col-md-6 pr-2" v-bind:style="width > 1023 ? 'padding-left: 18px' : ''">
                    <p>Our services aim at all your system and network infrastructure needs and cover various levels of administration - from creation to execution and ongoing management. We offer continuous system administration at affordable costs that allow lowering your maintenance and recovery costs.</p>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-md-12 inter-style small-description font-weight-normal dark-grey">
                    <p>How can we help</p>
                    <ul class="pl-3">
                      <li>Enterprise Solutions</li>
                      <li>Cloud Computing</li>
                      <li>Hardening Network Infrastructure</li>
                    </ul>
                    <p v-bind:class="['xs_margint', {'mt-5' : width > 1023}]">Clients that trusted us with Software Development</p>
                  </div>
                </div>
                <div v-bind:class="['row container-fluid', {'px-0 mx-0' : width <= 768}, {'pl-0' : width > 768}]">
                  <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'justify-content-start' : width > 1023}, {'justify-content-center': width <= 1023}]"><img class="groupon-logo" src="../assets/groupon.png"/></div>
                  <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'justify-content-center' : width < 1024}, {'justify-content-start' : width >= 1024}]"><img class="vodafone-logo" src=".././assets/vodafone.png"/></div>
                  <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'mt-4' : width <= 575}, {'justify-content-center' : width < 1024}, {'justify-content-start' : width >= 1024}]"><img class="gdfsuez-logo" src=".././assets/gdf-suez.png"/></div>
                  <div v-bind:class="['col-lg-2 col-sm-4 d-flex align-items-center col-6', {'mt-4' : width <= 993}, {'justify-content-center' : width < 1024}, {'justify-content-end' : width >= 1024}]"><img  class="orange-logo" src=".././assets/orange.png"/></div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
        <b-tab @click="tabsBehaviour" title="24/7 Support & Maintenance">
          <b-card-text>
            <div class="row mt-lg-5 xs_margint mb-5">
              <div class="col-md-4"><p v-bind:class="['title robot-style dark-grey tabs_title', {'mb-0':width<=768}]">24/7 Support & Maintenance</p></div>
              <div class="col-md-8 pl-sm-5 pl-lg-2  pr-0">
                <div v-bind:class="['row description lighter-grey small-description inter-style font-weight-normal xs_margint', {'mt-4' : width > 1023}]">
                  <div class="col-md-6 pr-2">
                    <p>24/7 Support and Maintenance translates into increased efficiency, enhanced customer experience, minimum downtime, and better security.</p>
                  </div>
                  <div class="col-md-6 pr-2" v-bind:style="width > 1023 ? 'padding-left: 18px' : ''">
                    <p>We have years of experience in offering reactive, responsive and proficient support services post-launch. This way, your business applications, and products will run successfully and error-free.</p>
                  </div>
                </div>
                <div class="row mt-4">
                  <div class="col-md-12 inter-style small-description font-weight-normal dark-grey">
                    <p>How can we help</p>
                    <ul class="pl-3">
                      <li>Enterprise Solutions</li>
                      <li>Cloud Computing</li>
                      <li>Hardening Network Infrastructure</li>
                    </ul>
                    <p v-bind:class="['xs_margint', {'mt-5' : width > 1023}]">Clients that trusted us with Software Development</p>
                  </div>
                </div>
                <div v-bind:class="['row container-fluid', {'px-0 mx-0' : width <= 768}, {'pl-0' : width > 768}]">
                  <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'justify-content-start' : width > 1023}, {'justify-content-center': width <= 1023}]"><img class="groupon-logo" src="../assets/groupon.png"/></div>
                  <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'justify-content-center' : width < 1024}, {'justify-content-start' : width >= 1024}]"><img class="vodafone-logo" src=".././assets/vodafone.png"/></div>
                  <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'mt-4' : width <= 575}, {'justify-content-center' : width < 1024}, {'justify-content-start' : width >= 1024}]"><img class="gdfsuez-logo" src=".././assets/gdf-suez.png"/></div>
                  <div v-bind:class="['col-lg-2 col-sm-4 d-flex align-items-center col-6', {'mt-4' : width <= 768}, {'justify-content-center' : width < 1024}, {'justify-content-end' : width >= 1024}]"><img  class="orange-logo" src=".././assets/orange.png"/></div>
                  <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {' mt-4' : width <= 768}, {'justify-content-center' : width < 1024}, {'justify-content-end' : width >= 1024}]"><img class="ferrero-logo" src=".././assets/ferrero.png"/></div>
                  <div v-bind:class="['col-lg-2 col-sm-4 col-6 d-flex align-items-center', {'mt-4' : width <= 768}, {'justify-content-center' : width < 1024}, {'justify-content-end' : width >= 1024}]"><img class="cocacola-logo" src=".././assets/coca-cola.png"/></div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>
      </b-tabs>
  </div>
  <howwework></howwework>
  <div class="row smallgrey-container">
    <div class="container container-paddingt container-paddingb">
      <div class="row"><h2 class="col-md-11 dark-grey title roboto-style">Our team has experience</h2><h2 class="col-md-11 dark-grey title roboto-style">delivering solutions in multiple industries</h2></div>
      <div class="row mt-3"><p class="col-lg-6 col-md-10 description inter-style medium-grey">Which are based on years of experience in multiple industries and deep understanding of business needs.</p></div>
      <div class="row inter-style dark-grey small-description mt-lg-5 mt-2">
        <div class="col-md-4">
          <p class="mb-0">· Telecommunication</p>
          <p class="mb-0">· Public Sector /Government </p>
          <p class="mb-0">· FMCG</p>
        </div>
        <div class="col-md-4">
          <p class="mb-0">· Health</p>
          <p class="mb-0">· Media & Entertainment</p>
          <p class="mb-0">· Beauty</p>
        </div>
        <div class="col-md-4">
          <p class="mb-0">· Fashion</p>
          <p class="mb-0">· Energy</p>
          <p class="mb-0">· Finance</p>
        </div>
      </div>
    </div>
  </div>
<conversation></conversation>
</div>
</template>

<script>
  import icnserv1 from "./icnserv1";
  import icnserv2 from "./icnserv2";
  import icnserv3 from "./icnserv3";
  import icnserv4 from "./icnserv4";
  import icnserv5 from "./icnserv5";
  import icnserv6 from "./icnserv6";
  import icnserv7 from "./icnserv7";
  import conversation from "./conversation";
  import howwework from "./howwework";
  export default {
      data() {
          return {
              tabindex: 0,
              width: 0
          }
      },
      components: {
          icnserv1,
          icnserv2,
          icnserv3,
          icnserv4,
          icnserv5,
          icnserv6,
          icnserv7,
          conversation,
          howwework,

      },
      computed: {
        windowWidth: {
            get: function () {
                return this.width;
            },
            set: function (val) {
                this.width = val;
            }

        }
      },
      methods: {
        scrollEvent() {
            if(window.innerWidth > 1027) {
                if (document.getElementsByClassName("tabs")[0].classList.contains("initial_padding")) {
                    if (document.documentElement.scrollTop >= 837) {
                        document.getElementsByClassName("card-header")[0].classList.add("fixed-header");
                    } else {
                        document.getElementsByClassName("card-header")[0].classList.remove("fixed-header");
                    }
                } else {
                    if (document.documentElement.scrollTop >= 715) {
                        document.getElementsByClassName("card-header")[0].classList.add("fixed-header");
                    } else {
                        document.getElementsByClassName("card-header")[0].classList.remove("fixed-header");
                    }
                }
            }
        },
          tabsBehaviour() {
              document.getElementsByClassName("tabs")[0].classList.remove("initial_padding");
              if(window.innerWidth > 1027) {
                  document.documentElement.scrollTop = 830;
              } else {
                  document.documentElement.scrollTop = 393;
              }

          },
          whitebox_click(e) {
            this.tabindex = Number(e.target.id);
            this.tabsBehaviour();
          }
      },
      mounted() {
          this.width = window.innerWidth;
          window.scrollTo(0, 0);
          window.addEventListener("scroll", this.scrollEvent);
          window.addEventListener('resize', () => {
              this.windowWidth = window.innerWidth;
          });
      },
      beforeDestroy() {
          window.removeEventListener("scroll", this.scrollEvent);
      }
  }
</script>

<style lang="scss" scoped>
  @import "../style/vars.scss";
  @import "../style/mixins.scss";
  .whitebox {
    background: #FFFFFF;
    border: 1px solid #EAECEF;
    box-sizing: border-box;
    border-radius: 2px;
    @include size(lg) {
      max-width: 149px;
    }
    @include size(sm) {
      max-width: 149px;
    }
    padding-top: 10px;
    cursor: pointer;
    box-shadow: 0px 17px 31px rgba(99, 102, 109, 0.07);
    p {
      color: #090909;
    }
  }
  .whitebox:hover {
    box-shadow: none;
    border-color: #090909;
    p{
      color: #00FF00;
    }
  }
  .initial_padding {
    padding-top: 125px;
  }
  li{
    list-style-type: none;
  }
  li::before {
    content: "·";
    position: absolute;
    left: 17px;
  }
</style>



// WEBPACK FOOTER //
// src/components/services.vue